import * as React from 'react';
import { SurfaceContextWithProperties } from '../../../types/contexts';
import { createSurfaceContextWithPropertiesProvider } from '../../common/surface-context-provider';

export interface McpPromotionDialogContextProperties {}

export const McpPromotionDialogContext = React.createContext<
    SurfaceContextWithProperties<McpPromotionDialogContextProperties>
>({ isOpen: false });

export const McpPromotionDialogContextProvider =
    createSurfaceContextWithPropertiesProvider<McpPromotionDialogContextProperties>(McpPromotionDialogContext);
